export default {
  // 宽松实名校验，未安装安伴门锁且未在无锁上传白名单的门店，订单不展示「人工认证」入口和认证上传
  looseRecord(state) {
    const { hotelLockState, hotelType } = state.house.hotelInfo
    return hotelLockState === 1 && hotelType === 0
  },
  // 是否拥有当前一级路由的权限
  hasAuth: (state) => {
    const { roleList, userType } = state.permissions
    if (userType === 1) {
      return true
    }
    // 如果没有这个字段, 说明请求失败了, 默认返回有权限
    if (!roleList) {
      return true
    }
    if (roleList.includes(1001)) {
      return true
    } else {
      if (state.currentRoute.matched[1].meta.auth) {
        return roleList.includes(state.currentRoute.matched[1].meta.auth)
      } else {
        return true
      }
    }
  },
  // 是否拥有财务权限, 没有权限不展示记一笔
  hasFinanceAuth: (state) => {
    const { roleList, userType } = state.permissions
    if (userType === 1) {
      return true
    }
    if (!roleList) {
      return true
    } else {
      return roleList.includes(1008)
    }
  }
}
